import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { CushionMaterial, PaintColorMaterial } from '../../utils/materials';

export function Judy_dining_chair_painted(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Judy Dining Chair - Painted.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);
  // uuid 131
  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-judy_dining_chair_painted-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    CushionMaterial,
    currentMaterialFinish.cushionFinish,
    defaultFinish.cushionFinish,
    'ao-judy_dining_chair_painted-cushion',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
        position={[0, 0.4, -0.034]}
      />
      {currentFinishes.cushionFinish !== 'No Cushion' ? (
        <>
          <mesh
            castShadow
            geometry={nodes.Cushion.geometry}
            material={CushionMaterial}
            position={[0, 0.483, -0.005]}
          />
          <mesh
            castShadow
            geometry={nodes.Stiches.geometry}
            material={materials.Stiches}
            position={[0, 0.469, -0.188]}
          />
          <mesh
            castShadow
            geometry={nodes.Ziper.geometry}
            material={materials.Ziper}
            position={[0, 0.469, -0.12]}
          />
        </>
      ) : null}
      <Shadow model={'Judy Dining Chair - Painted'} />
    </group>
  );
}
